import { findIndex, some } from 'lodash-es';
import { OnboardingTask } from '../types';

export const getFirstNotDoneTaskIndex = (onboardingTasksList: OnboardingTask[]): number => {
    const checkForCompletedOrSkippedStep = (steps) => some(steps, (step) => !step.isCompleted && !step.isSkipped);
    return findIndex(onboardingTasksList, (task) =>
        checkForCompletedOrSkippedStep(task.steps?.[task.activeStepsIndex]?.items)
    );
};
